module.exports = __webpack_public_path__ + "img/bg02.fb264819.jpg";